module.exports = require("./am.d.ts");